<template>
  <div>
    <sidebar />
    <div class="relative md:ml-64 bg-blueGray-100">
      <admin-navbar />
      <header-stats />
      <div class="px-4 md:px-10 mx-auto w-full -m-24">
        <router-view />
        <footer-admin />
      </div>
    </div>
  </div>
</template>
<script>
import AdminNavbar from "~/components/old/Navbars/AdminNavbar.vue";
import Sidebar from "~/components/old/Sidebar/Sidebar.vue";
import HeaderStats from "~/components/old/Headers/HeaderStats.vue";
import FooterAdmin from "~/components/old/Footers/FooterAdmin.vue";
export default {
  name: "admin-layout",
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
    FooterAdmin,
  },
};
</script>
